import React from 'react';
import Spinner from '~/_base/components/spinner';
import { BrowserRouter as Router } from 'react-router-dom';
import { UnauthenticatedRoutes } from './routes';
import Centered from '~/_base/components/centered';

export default function UnauthenticatedApp() {
  return (
    <React.Fragment>
      <Router>
        <React.Suspense
          fallback={
            <Centered>
              <Spinner />
            </Centered>
          }
        >
          <UnauthenticatedRoutes />
        </React.Suspense>
      </Router>
    </React.Fragment>
  );
}
